export const initMenu = () => {
    const hamburgerIcon = document.getElementById('hamburger-icon');
    const mobileMenuContainer = document.getElementById('mobile-menu');
    const menuItemsHasSub = document.querySelectorAll('.open-sub');

    hamburgerIcon.addEventListener('click', () => {
        if (mobileMenuContainer.classList.contains('open')) {
            mobileMenuContainer.classList.remove('open');
            mobileMenuContainer.style.maxHeight = '0';
        } else {
            mobileMenuContainer.classList.add('open');
            mobileMenuContainer.style.maxHeight = mobileMenuContainer.scrollHeight + 'px';
        }
    });

    Array.from(menuItemsHasSub).forEach((element) =>
        element.addEventListener('keydown', (e: KeyboardEvent) => {
            if (e.key == 'Enter') {
            e.preventDefault();
            element.parentElement.nextElementSibling.classList.toggle('open');
            console.log(element.parentElement.nextElementSibling);
            } else if (e.key == 'Tab') {
            if (
                !element.parentElement.nextElementSibling.classList.contains('open')
            ) {
                element.parentElement.nextElementSibling.classList.remove('open');
            }
            }
            document.addEventListener('keydown', (e: KeyboardEvent) => {
            if (e.key == 'Escape') {
                element.parentElement.nextElementSibling.classList.remove('open');
            }
            document.removeEventListener('keydown', null);
            });
        })
    );

    // Event listener to close the menu when clicking outside of it
    document.addEventListener('click', function (event) {
        var isClickInsideMenu = mobileMenuContainer.contains(event.target as Node);
        var isClickHamburgerIcon = hamburgerIcon.contains(event.target as Node);
        if (!isClickInsideMenu && !isClickHamburgerIcon) {
            mobileMenuContainer.style.maxHeight = '0';

            if (mobileMenuContainer.classList.contains('open')) {
                mobileMenuContainer.classList.remove('open');
            }
        }
    });
};
